export default __webpack_public_path__ + "static/media/cure_suggestion.54a23ab9.png";